import { Heading } from "@digipost/dds-heading-react";
import { FC, ReactNode } from "react";
import { Link } from "react-router";

import Translated from "../infrastructure/components/Translated";
import { APPSTORE_URL, PLAYSTORE_URL } from "../infrastructure/constants";
import { useIsMobilapp } from "../mobileapp/utils";
import Mobilmedbrev from "../utlogging/mobilmedbrev.svg?react";
import styles from "./AppCommercialBanner.module.less";
import Appstore from "./iOS.svg?react";
import Playstore from "./Play.svg?react";

const AppLogoLink: FC<{
  link: string;
  image: ReactNode;
}> = ({ link, image }) => {
  return (
    <Link to={link} className={styles.appLogoLink} aria-hidden={true}>
      {image}
    </Link>
  );
};

export const AppCommercialBanner: FC = () => {
  const isMobilapp = useIsMobilapp();

  if (isMobilapp) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageBox}>
        <Mobilmedbrev />
      </div>
      <div>
        <Heading level={2} size={"medium"} className={styles.heading}>
          <Translated textKey="app.heading" />
        </Heading>
        <p className={styles.subheading}>
          <Translated
            textKey={"app.subheading"}
            allowHtml={true}
            params={{
              //Om disse lenkene fjernes så må aria-hidden={true} i AppLogoLink fjernes slik at skjermleser har en annen lenke å gå til
              playstore_url: PLAYSTORE_URL,
              appstore_url: APPSTORE_URL,
            }}
          />
        </p>
        <div className={styles.appLogos}>
          <AppLogoLink link={APPSTORE_URL} image={<Appstore />} />
          <AppLogoLink link={PLAYSTORE_URL} image={<Playstore />} />
        </div>
      </div>
    </div>
  );
};
